import React from "react";

function CensoTable(props) {
  return (
    <table className="table-layers-results">
      <thead>
        <tr>
          <th style={{ width: '300px' }} className="name no-select">Nombre</th>
          <th className="name no-select">Documento</th>
          <th className="name no-select">Local</th>
          <th className="name no-select">Fecha</th>
          <th className="name no-select">Acciones</th>
        </tr>
      </thead>
      <tbody>
        {props.list.map((item) => (
          <tr key={"row-table-hg-ash-" + item.id}>
            <td style={{ width: '300px' }} className="user">
              {`${item.name ?? ''} ${item.lastName1 ?? ''} ${item.lastName2 ?? ''}`}
            </td>
            <td className="user no-select">{item.docNumber}</td>
            <td className="user no-select">{item.shopNumber}</td>
            <td className="user">{item.now ? item.now.split('T')[0] : ''}</td>
            <td className="user no-select pointer flex-center">
              <div className="flex-center">
                <div onClick={() => props.onGetPdf(item.id)} className={'kml-input-form-bottons red-background-color on-mouse-hover'} title={'Descargar PDF'}>
                  <i className="fa fa-file-pdf"></i>
                </div>
              </div>
              <div className="flex-center">
                <div onClick={() => props.onOpen(item.id)} className={'kml-input-form-bottons green-background-color on-mouse-hover'} title={'Ver información'}>
                  <i className="fas fa-eye"></i>
                </div>
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

export default CensoTable;
